import React from 'react';
import { Query } from '@apollo/client/react/components';

import NavigationItem from '../NavigationItem/NavigationItem';
import gql from 'graphql-tag';
import { CurrentUser } from './__generated__/CurrentUser';

export const CURRENT_USER_QUERY = gql`
    query CurrentUser {
        me {
            user {
                certifications
                isDesigner
            }
        }
    }
`;

export function BrowseProjectsNavigationItem() {
    return (
        <Query<CurrentUser>
            query={CURRENT_USER_QUERY}
            notifyOnNetworkStatusChange
            fetchPolicy="cache-and-network"
        >
            {(queryResult) => {
                const { data } = queryResult;
                if (!data || !data.me || !data.me.user) {
                    return null;
                }
                const { certifications, isDesigner } = data.me.user;

                const certifiedForSquare =
                    certifications.includes('square-online-store') &&
                    certifications.includes('square-online-store-web');
                const certifiedForSquarespace = certifications.includes('squarespace');
                if (isDesigner && (certifiedForSquarespace || certifiedForSquare)) {
                    return (
                        <NavigationItem
                            label={'Browse projects'}
                            url="/projects/browse"
                            icon="notebook-3"
                            highlightNew={true}
                        />
                    );
                }

                return null;
            }}
        </Query>
    );
}

export default function YourWorkMenu({ isStaticTemplate = false }: { isStaticTemplate?: boolean }) {
    return (
        <div className="menu menu--constrained">
            <div className="menu__inner">
                <ul className="menu__item menu__item--action-list">
                    <NavigationItem
                        label={__('Contests')}
                        url="/contests/your-contests"
                        icon="folder-1"
                    />

                    <NavigationItem label={__('Projects')} url="/projects/active" icon="folder-1" />

                    <NavigationItem
                        label={__('Browse contests')}
                        url="/contests/browse"
                        icon="notebook-3"
                    />

                    {isStaticTemplate && (
                        <li className={'hidden'} data-globalnav-your-work-menu-browse-projects />
                    )}
                    {!isStaticTemplate && <BrowseProjectsNavigationItem />}
                </ul>
            </div>
        </div>
    );
}
